import { BearerToken as BaseBearerToken }	from "ts-base/web/bearerToken";

import { Textual }	from "@v3/data/textual";

// as defined in https://datatracker.ietf.org/doc/html/rfc6750#section-2.1
export type BearerToken		= Textual.Value<typeof BearerToken>;
export const BearerToken	= Textual.fromBase(BaseBearerToken, "must be an RFC 6750 b64token");
